import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

export const authGuard: CanActivateFn = (route, state): Observable<boolean | UrlTree> => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  return authService.getAuthState().pipe(
    take(1), // Complete after the first emission
    map(user => {
      if (user) {
        return true; // User is logged in, allow access
      } else {
        // User is not logged in, redirect to login page, preserving attempted URL
        return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
      }
    })
  );
};
